// researchSchemaEnhancer.jsx
import messages from '../../../messages';

export const researchSchemaEnhancer = ({ schema, formData, intl }) => {
  const isThisVariation =
    formData?.variation === 'research' || formData?.template === 'research';

  if (!isThisVariation) return schema;

  schema.properties.moreLinkLabel = {
    title: 'Footer-Text:',
    type: 'string',
    default: 'Weitere Förderungen anzeigen',
  };

  schema.properties.moreLinkHref = {
    title: 'Footer-Link:',
    description: intl.formatMessage(messages.listingFootnote),
    widget: 'object_browser',
    mode: 'link',
  };

  const fs =
    schema.fieldsets?.find((f) => f.id === 'default') || schema.fieldsets?.[0];
  if (fs) {
    if (!fs.fields.includes('moreLinkLabel')) fs.fields.push('moreLinkLabel');
    if (!fs.fields.includes('moreLinkHref')) fs.fields.push('moreLinkHref');
  }

  return schema;
};
